import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { Home, Dumbbell, UtensilsCrossed, TrendingUp, Settings, LogOut, BookOpen } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import styles from './Layout.module.css';

const navItems = [
  { path: '/', icon: Home, label: 'Today' },
  { path: '/exercises', icon: Dumbbell, label: 'Exercises' },
  { path: '/nutrition', icon: UtensilsCrossed, label: 'Nutrition' },
  { path: '/progress', icon: TrendingUp, label: 'Progress' },
  { path: '/notes', icon: BookOpen, label: 'Journal' },
  { path: '/settings', icon: Settings, label: 'Settings' },
];

export default function Layout() {
  const { signOut, user } = useAuth();

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <div className={styles.logo}>
          <div>
            <h1 className={styles.logoText}>beryl</h1>
            <p className={styles.logoTagline}>Your Recovery Buddy</p>
          </div>
        </div>
        <nav className={styles.nav}>
          {navItems.map(item => (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.path === '/'}
              className={({ isActive }) => `${styles.navItem} ${isActive ? styles.navItemActive : ''}`}
            >
              <item.icon size={20} />
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className={styles.sidebarFooter}>
          <div className={styles.userInfo}>
            <div className={styles.avatar}>
              {user?.email?.charAt(0).toUpperCase()}
            </div>
            <span className={styles.userEmail}>{user?.email}</span>
          </div>
          <button onClick={signOut} className={styles.signOutBtn}>
            <LogOut size={18} />
            <span>Sign Out</span>
          </button>
        </div>
      </aside>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
